import React, { Component } from 'react';
import { HeadingContainer, TransparentButton, ColorButton, DeleteModal, SwitchContainer, EmptyStateContainer } from '../../../../../neoverv';
import { Row, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import Autoload from '../../../../../neoverv/Autoload';
import { isStarterTier } from '../../../../../helpers/subscriptionFeatureAccess';
import { getBrandingPartner } from '../../../../../helpers/partners';
import {
  updateUserProfile,
  Account_info,
  updateProfilePicture,
  setProfileData,
  setCompanyLogo,
  updateCompanyLogo,
  setAccountData,
  setIsLogoHidden
} from '../../../../../redux/action/General/generalActions';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RightArrowPartner from '../../../../../assets/images/module/general/RightArrowPartner.svg';
import Avatar from '../../../../../assets/images/module/general/UserAccountBlue.svg';
import { Group, Skeleton, Stack } from '@mantine/core';
import BuyPremiumModal from '../../../../../neoverv/components/Module/General/CustomModal/BuyPremiumModal';
import { showNotification } from '@mantine/notifications';
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default].general;
var lang2 = Setting[Setting.language_default].newKeys;
const { checkProperty, loader } = Autoload.MainHelper;
const MOBILE_SIZE = 500;

export class CompanyDetails extends Component {
  state = {
    email: '',
    emailErr: false,
    firstName: '',
    firstnameErr: false,
    lastName: '',
    lastnameErr: false,
    address: '',
    addressErr: false,
    city: '',
    cityErr: false,
    zip: null,
    zipErr: false,
    company: '',
    companyErr: false,
    file: '',
    fileToUpload: '',
    deleteAccountModal: false,
    fileUploadErr: { state: false, msg: '' },
    isMobile: window.innerWidth < MOBILE_SIZE,
    skeletonLoading: false,
    buyPremiumModalOpen: false,
    accountData: null,
    enableCompanyLogoUse: 'SystemDefault',
    isLogoHiddenState: false,
    logoPreference: 'SystemDefault'
  };

  componentDidMount() {
    this.setState({skeletonLoading: true});
    this._fetch_UserInfoData();
    // this.getUserPicture();
    // const { profile } = this.props;
    // // console.log(profile, 'profile');
    // this.setState({
    //   email: checkProperty(profile, 'email'),
    //   name: checkProperty(profile, 'name'),
    //   address: checkProperty(profile, 'address'),
    //   city: checkProperty(profile, 'city'),
    //   zip: checkProperty(profile, 'zip', null),
    //   company: checkProperty(profile, 'company'),
    //   file: checkProperty(profile, 'file'),
    // });
  }
  toggleDeleteAccountModal = () => {
    this.setState({ deleteAccountModal: !this.state.deleteAccountModal });
  };

  _get_UserProfilePic = () => {
    console.log('this.props.profile picture', this.props.profile);
    const userAccountID = this.props.profile.id;
    console.log(userAccountID, 'userAccountID profile');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_api_baseurl + userAccountID + '/picture',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_pic',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handle_get_pic = (response) => {
    console.log('user profile picture', response);
    // if (response.status == false) {
    //   Autoload.Redirection.redirection_error();
    // }
    if (response.status == true && response.statuscode == 200) {
      this.setState({ file: response.result ? response.result : '' });
    }
  };

  _fetch_UserInfoData() {
    console.log('this.props.profile', this.props.profile);
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.account_api_baseurl + 'b13c75a4-ddaa-4102-c080-08d92bf06bb3',
      //Autoload.Setting.swagger_mocked_api_baseUrl + '/users/1',
      Autoload.Setting.user_api_baseurl + this.props.profile.id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_user_list_data_one',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handle_get_user_list_data_one(response) {
    console.log('response of profile api one', response.result);
    this.props.Account_info(response.result.accountId);
    // api one - company city zipcode street streetNo
    // this.setState({ email: response.result[0].email });
    var data = response.result;
    console.log(data, 'data profile api one ');

    setTimeout(() => {
      Autoload.HttpRequestAxios.HttpRequest(
        // Autoload.Setting.user_api_baseurl + 'b13c75a4-ddaa-4102-c080-08d92bf06bb3',
        Autoload.Setting.account_api_baseurl + this.props.profile.accountId,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handle_get_user_list_data_two',
        { data: data },
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }, 500);
  }
  handle_get_user_list_data_two(response) {
    console.log('response of profile api two', response);

    // console.log(response.other.data.result);
    // const fullname =
    //   Autoload.MainHelper.checkProperty(response.other.data, 'firstName') +
    //   ' ' +
    //   Autoload.MainHelper.checkProperty(response.other.data, 'lastName');
    // console.log(fullname, 'fullname');

    this.setState({
      // name: fullname,
      firstName: Autoload.MainHelper.checkProperty(response.other.data, 'firstName'),
      lastName: Autoload.MainHelper.checkProperty(response.other.data, 'lastName'),
      email: Autoload.MainHelper.checkProperty(response.other.data, 'email'),
      accountID: Autoload.MainHelper.checkProperty(response.other.data, 'accountId'),
      address: Autoload.MainHelper.checkProperty(response.result, 'addressStreet'),
      city: Autoload.MainHelper.checkProperty(response.result, 'addressCity'),
      zip: Autoload.MainHelper.checkProperty(response.result, 'addressZipCode'),
      company: Autoload.MainHelper.checkProperty(response.result, 'addressCompany'),
      accountNo: Autoload.MainHelper.checkProperty(response.result, 'accountNo'),
      companyEmail: Autoload.MainHelper.checkProperty(response.result, 'companyEmail'),
      companyPhoneNumber: Autoload.MainHelper.checkProperty(response.result, 'companyPhoneNumber'),
      file: Autoload.MainHelper.checkProperty(response.result, 'pictureLocation'),
      enableCompanyLogoUse: response?.result?.logoPreference,
      enableLogoUse: response?.result?.logoPreference,//Autoload.MainHelper.checkProperty(response.result, 'useOwnLogo'),
      accountData: response.result,
      isLogoHiddenState: response?.result?.logoPreference === 'None',
      logoPreference: response?.result?.logoPreference
    },()=> this.setState({prevState: this.state}));
    this.props.setProfileData({
      ...this.props.profile,
      firstName: Autoload.MainHelper.checkProperty(response.other.data, 'firstName'),
      lastName: Autoload.MainHelper.checkProperty(response.other.data, 'lastName'),
      email: Autoload.MainHelper.checkProperty(response.other.data, 'email'),
      accountID: Autoload.MainHelper.checkProperty(response.other.data, 'accountId'),
      address: Autoload.MainHelper.checkProperty(response.result, 'addressStreet'),
      city: Autoload.MainHelper.checkProperty(response.result, 'addressCity'),
      zip: Autoload.MainHelper.checkProperty(response.result, 'addressZipCode'),
      company: Autoload.MainHelper.checkProperty(response.result, 'addressCompany'),
      accountNo: Autoload.MainHelper.checkProperty(response.result, 'accountNo'),
      companyEmail: Autoload.MainHelper.checkProperty(response.result, 'companyEmail'),
      companyPhoneNumber: Autoload.MainHelper.checkProperty(response.result, 'companyPhoneNumber'),
      pictureLocation: Autoload.MainHelper.checkProperty(response.result, 'pictureLocation'),
      useOwnLogo: response?.result?.logoPreference,//Autoload.MainHelper.checkProperty(response.result, 'useOwnLogo'),
      isLogoHiddenState: response?.result?.logoPreference === 'None',
      logoPreference: response?.result?.logoPreference
    });

    this.props.setIsLogoHidden(response?.result?.logoPreference === 'None');
    this.props.setCompanyLogo(response?.result?.logoPreference);//Autoload.MainHelper.checkProperty(response.result, 'useOwnLogo'));
    this.ShowLoader();
  }

  _put_userAccountInfo() {
    this.setState({skeletonLoading: true});
    const userAccountID = this.props.profile.accountId;
    //let btnelement = document.getElementById('save-btn-userProfile-info');
    const userInforData = {
      ...this.state.accountData,
      accountId: userAccountID,
      addressCompany: this.state.company,
      companyEmail: this.state.companyEmail,
      companyPhoneNumber: this.state.companyPhoneNumber,
      addressStreet: this.state.address,
      addressCity: this.state.city,
      addressZipCode: this.state.zip,
      //useOwnLogo: this.state.enableLogoUse,
      logoPreference: this.state.logoPreference//this.state.isLogoHiddenState ? 'None' : this.state.enableCompanyLogoUse === 'None' ? 'SystemDefault' : this.state.enableCompanyLogoUse
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + userAccountID,
      'PUT',
      userInforData,
      null,//btnelement.children[0],
      false,
      true,
      false,
      this,
      'handle_put_userCompanyInfo',
      { userInforData },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handle_put_userCompanyInfo(response) {
    console.log('put user info data one', response);
    let btnelement = document.getElementById('save-btn-userProfile-info');
    // this.props.Account_info(123);
    // let profileData = {
    //   email: response.result.email,
    //   firstName: response.result.firstName,
    //   lastName: response.result.lastName,
    //   phoneNumber: response.result.phoneNumber,
    //   accountId: response.result.accountId
    // };
    if(response.status){
      window.Intercom("update", {
        'Company': response.other.userInforData.addressCompany,
        'Company Email': response.other.userInforData.companyEmail,
        'Company Phone': response.other.userInforData.companyPhoneNumber,
      });
      window.Intercom('trackEvent', 'profile-updated');
      this.props.setAccountData(response.result);
      showNotification({
        id: 'save_account_info_successful',
        icon: <img src={GreenTick} alt='green-tick'/>,
        message: 'Die Änderungen wurden übernommen.',
      })
    }else{
      showNotification({
        id: 'save_account_info_failed',
        message: 'Die Änderungen wurden nicht gespeichert.',
        icon: <img src={RedCross} alt='red-tick'/>,
      });
    }

    if (this.state.file) {
      if (this.state.fileToUpload) {
        this.putCompanyPicture(this.props.profile.accountId, null);
      }else{
        this.setState({skeletonLoading: false});
        this._fetch_UserInfoData();
      }
    }else{
      this.setState({skeletonLoading: false});
      this._fetch_UserInfoData();
    }
  }

  putCompanyPicture(id, updatedUserData) {
    const payload = new FormData();
    payload.append('file', this.state.file ? this.state.fileToUpload : null);
    let btnelement = document.getElementById('save_userProfile_picture');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + id + '/picture',
      'PUT',
      payload,
      btnelement.children[0],
      false,
      true,
      false,
      this,
      'put_company_picture_Response',
      null,
      false,
      '',
      { 'Content-Type': 'application/json', Authorization: Autoload.Utils.getAuthToken() }
    );
  }

  put_company_picture_Response(response) {
    console.log('put_company_picture_Response', response);
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(
        true,
        lang.newKeys.text_error_not_found
        // + response.message
      );
    }
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      //this.props.updateProfilePicture(response.result);
      this.props.updateCompanyLogo(response.result);
    }

    this.setState({skeletonLoading: false});
    this._fetch_UserInfoData();
    // ;
    // this.updateProperties(response.other.updated_property_response);
  }

  deleteCompanyPicture(id, updatedUserData) {
    let btnelement = document.getElementById('delete-user-profile-button_id');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + id + '/picture',
      'DELETE',
      null,
      btnelement.children[0],
      false,
      true,
      false,
      this,
      'handle_delete_Company_Picture',
      { cancelbtn: btnelement.children[0], updatedUserData: updatedUserData },
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_delete_Company_Picture(response) {
    // ;
    console.log('handle_delete_Company_Picture', response);
    // ;
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(
        true,
        lang.newKeys.text_error_not_found
        // + response.message
      );
    }
    this.setState({
      file: null,
    });
    //update  api run
    // this.update_User_Profile(response.other.Profiledata);
  }

  cancelSubscriptionAPi=()=> {
    const {currentSubscription} = this.props;
    if(currentSubscription?.subscriptionAmount > 0 && currentSubscription?.subscriptionStatus === 'ACTIVE') {
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.account_profile_subscription_api_baseurl + 'subscriptionAssignments/' + this.props.currentSubscription?.subscriptionAssignment + '/cancel',
        'PUT',
        null,
        null,
        false,
        true,
        false,
        this,
        'handle_cancel_subscription',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }else{
      setTimeout(() => {
        this.deleteAccount();  
      }, 1000);
    }
  }

  handle_cancel_subscription(response) {
    this.setState({ openModal: !this.state.openModal });
    if(response.status){
      var metadata = {
        subscriptionKey: this.props.currentSubscription?.subscriptionKey
      };
      window.Intercom('trackEvent', 'plan-cancelled', metadata);
      showNotification({
        message: 'Die Kündigung Ihres aktuellen Abonnements war erfolgreich.',
        icon: <img src={GreenTick} alt='green-tick'/>,
      });
      setTimeout(() => {
        this.deleteAccount();  
      }, 1000);
    }
    else{
      showNotification({
        message: 'Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
    }
    
  }

  deleteAccount() {
    loader(true);
    let btnelement = document.getElementById('delete-user-profile');
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + this.props.profile.accountID + '/DeActivate',
      'PUT',
      null,
      btnelement.children[0],
      false,
      true,
      false,
      this,
      'handle_delete_userAccount',
      { cancelbtn: btnelement.children[0] },
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_delete_userAccount(response) {
    console.log('delete user account', response);
    // debugger;
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(
        true,
        lang.newKeys.text_error_not_found
        // + response.message
      );
    }

    if(response.status && response.statuscode === 200){
      window.Intercom('trackEvent', 'account-deleted');
      window.Intercom("update", {
        'Account Deleted': true,
        'Current Plan': 'CANCELLED'
      });
      setTimeout(() => {
        loader(false);
        Autoload.Utils.clear_session_data();
        window.location.href = "/login";
        window.Intercom('shutdown');
      }, 4000);
    }
  }

  handlePictureUpload = (e) => {
    e.preventDefault();
    if (e.target.files[0] && typeof e.target.files[0] != 'undefined') {
      let fileTypeErr = false;
      let fileDimensionErr = false;
      const file = e.target.files[0];
      // var pattern = /image-*/;
      // console.log('file type', file, file.type)
      if (!file.type.includes('image')) {
        fileTypeErr = true;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      const classContext = this;
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          // console.log('width', this.width, 'height', this.height)
          if (height < 240 || width < 240) {
            fileDimensionErr = true;
          }
          if (fileTypeErr || fileDimensionErr) {
            const msg = `Invalid file ${fileTypeErr ? 'type' : ''} ${fileTypeErr && fileDimensionErr ? 'and' : ''} ${fileDimensionErr ? 'dimension' : ''
              }`;
            classContext.setState({
              fileUploadErr: { state: true, msg },
            });
          } else {
            classContext.setState({
              file: URL.createObjectURL(file),
              fileToUpload: file,
              fileUploadErr: { state: false, msg: '' },
            });
            classContext.savePersonalChanges();
          }
        };
      };
    }
  };

  onInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handlePictureUpload_general = (e) => {
    const _put_userAccountInfo = ()=> this._put_userAccountInfo();
    e.preventDefault();
    if (e.target.files[0] && typeof e.target.files[0] != 'undefined') {
      let fileTypeErr = false;
      let fileDimensionErr = false;
      let fileSizeErr= false;
      const file = e.target.files[0];
      if (!file.type.includes('image')) {
        fileTypeErr = true;
      }
      const fileSize = file.size;
      const fileMb = fileSize / 1024 ** 2;
      if (fileMb >= 5) {
        fileSizeErr=true;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      const classContext = this;
      const props = this.props;
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          var height = this.height;
          var width = this.width;
          if (height < 240 || width < 240) {
            fileDimensionErr = true;
          }
          if (fileTypeErr || fileDimensionErr || fileSizeErr) {
            const msg = `${fileTypeErr ? 'Ungültiger Dateityp' : ''} ${fileTypeErr && fileDimensionErr ? 'und' : ''} ${fileDimensionErr ? 'Ungültige Bilddimensionen' : ''} ${fileSizeErr ? 'Dateigröße größer als 5 MB' : ''}`;
            classContext.setState({ fileUploadErr: { state: true, msg } });
          } else {
            if(file.size > 300000){
              Autoload.Utils.compressImage(file, res=>
              classContext.setState({
                file: URL.createObjectURL(file),
                fileToUpload: res,
                fileUploadErr: { state: false, msg: '' },
              },()=> _put_userAccountInfo()))
            }else{
              classContext.setState({
                file: URL.createObjectURL(file),
                fileToUpload: file,
                fileUploadErr: { state: false, msg: '' },
              },()=> _put_userAccountInfo());
            }
            // const payload = new FormData();
            // payload.append('fil', file, file.name);
            // Autoload.HttpRequestAxios.HttpRequest(
            //   Autoload.Setting.property_api_base_url + 'Properties/' + props.propertyData.id + '/Picture',
            //   'PUT',
            //   payload,
            //   null,
            //   false,
            //   true,
            //   false,
            //   classContext,
            //   '_handlePictureUpload',
            //   null,
            //   false,
            //   '',
            //   {
            //     'Content-Type': 'application/json',
            //     Authorization: Autoload.Utils.getAuthToken(),
            //   }
            // );
          }
        };
      };
    }
  };

  validatePersonalData = () => {
    this.setState({
      firstnameErr: false,
      lastnameErr: false,
      companyErr: false,
      addressErr: false,
      emailErr: false,
      cityErr: false,
      zipErr: false,
    });
    let emailErr,
      firstnameErr,
      addressErr,
      zipErr,
      companyErr,
      cityErr,
      lastnameErr,
      fileErr = false;
    //const validName = /^[a-zA-Z]+(?:[\s]+[a-zA-Z]+)*$/;
    const validName = /[^a-zA-Z0-9äöüÄÖÜß]/;
    const validEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.state.email || !validEmail.test(this.state.email)) {
      emailErr = true;
    }
    if (!this.state.firstName || !validName.test(this.state.firstName)) {
      firstnameErr = true;
    }
    if (!this.state.lastName || !validName.test(this.state.lastName)) {
      lastnameErr = true;
    }
    if (!this.state.address) {
      addressErr = true;
    }
    if (!this.state.city) {
      cityErr = true;
    }
    if (!this.state.zip || this.state.zip === null) {
      zipErr = true;
    }
    if (this.state.company && !validName.test(this.state.company)) {
      companyErr = true;
    }
    if (
      this.state.fileToUpload !== null &&
      this.state.fileToUpload !== '' &&
      this.state.fileToUpload !== undefined &&
      this.state.fileUploadErr.state
    ) {
      fileErr = true;
    }

    this.setState({ emailErr, firstnameErr, addressErr, zipErr, companyErr, cityErr, lastnameErr });
    if (emailErr || firstnameErr || addressErr || zipErr || companyErr || cityErr || fileErr || lastnameErr) {
      return false;
    }
    this.savePersonalChanges();
    return true;
  };

  // savePersonalChanges = () => {
  //   const { name, email } = this.state;
  //   let data = {
  //     userId: 1,
  //     accountId: this.props.profile.id,
  //     firstName: name.indexOf(' ') > 0 ? name.substr(0, name.indexOf(' ')) : name,
  //     lastName: name.indexOf(' ') > 0 ? name.substr(name.indexOf(' ') + 1) : '',
  //     email: email,
  //   };
  //   const userAccountID = this.props.profile.id;
  //   Autoload.HttpRequestAxios.HttpRequest(
  //     Autoload.Setting.swagger_mocked_api_baseUrl + 'users/' + userAccountID,
  //     'PUT',
  //     null,
  //     null,
  //     false,
  //     true,
  //     false,
  //     this,
  //     'handle_update_profile',
  //     null,
  //     false,
  //     '',
  //     {
  //       Authorization: Autoload.Utils.getAuthToken(),
  //     }
  //   );
  //   // const payload = { ...this.state };
  //   // this.props.updateUserProfile(payload);
  // };
  // handle_update_profile = (response) => {};
  ShowLoader = () => {
    console.log('show loader abc');
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
    var emptyDiv = document.getElementById('empty-user-account-personal-details');
    emptyDiv.style.display = 'none';
    var dataDiv = document.getElementById('response-user-account-personal-details');
    dataDiv.style.display = 'block';
    this.setState({skeletonLoading: false});  
  };

  renderLogo=()=>{
    const {skeletonLoading, logoPreference} = this.state;
    const {currentSubscription, accountData} = this.props;
    // The documents of a partner's customer (#2357) show the partner's logo where they'd show
    // hellohousing's, so that's the one previewed here too. It's wider than hellohousing's.
    const partner = getBrandingPartner(accountData, currentSubscription);
    const hhLogo = partner ? partner.pdfLogo : '/hello-housing-logo.svg';
    return (
      <div style={{ minWidth:"108px", width: partner ? 'auto' : '142px', height: '72px', display: skeletonLoading ? 'none' : 'block', marginRight: '30px'}}>
        <img alt="profile" style={{height: '72px'}} src={!isStarterTier(currentSubscription) ? logoPreference === 'SystemDefault' ? hhLogo : (this.state.file ? this.state.file : hhLogo) : hhLogo} />
      </div>
    )
  }

  render() {
    console.log(this.props.profile, this.state.accountID, 'this.props.profile');
    const {isMobile, skeletonLoading, buyPremiumModalOpen, enableCompanyLogoUse, isLogoHiddenState, logoPreference} = this.state;
    const {currentSubscription, accountData, hasTested, propertySelected} = this.props;
    const propertyOwnerInfoEnabled = propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled;
    return (
      <>
        <div id="empty-user-account-personal-details"></div>
        <div className="account-width personal" id="response-user-account-personal-details" style={{ display: 'block', width: isMobile ? '100%' : 'auto' }}>
          <div style={{width: isMobile ? '100%' : '380px'}}>
            <label className='tooltips company-contact-information-label' style={{marginTop: '25px', marginBottom: '18px'}}> {'Kontaktdaten'}</label>
            {propertyOwnerInfoEnabled &&
            <Row style={{marginBottom: '10px'}}>
              <Col xs={12}>
                <Group className='property-owner-info-enabled-notification-for-company-details-page'>
                  <span style={{fontSize: '12px', color: '#13135c', fontWeight: 400, width: 'fit-content'}}>Für diese Immobilie werden aktuell spezifische Eigentümerinformationen verwendet. Klicken Sie <span className='link-text' onClick={()=> this.props.history.push('/property/propertyOwnerInformation')}>hier</span>, um die <span className='link-text' onClick={()=> this.props.history.push('/property/propertyOwnerInformation')}>Eigentümerinformationen</span> anzuzeigen.</span>
                </Group>
              </Col>
            </Row>}
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label> {lang.text_company} <span className='required-feild'>*</span></Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-address"
                    name="person-address"
                    isInvalid={this.state.companyErr}
                    type="text"
                    value={this.state.company}
                    onChange={(e) => {
                      this.onInputChange('company', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.company && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_company}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label> {'Anschrift'} <span className='required-feild'>*</span></Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-address"
                    name="person-address"
                    isInvalid={this.state.addressErr}
                    type="text"
                    value={this.state.address}
                    onChange={(e) => {
                      this.onInputChange('address', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.address && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_address}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={8}>
                <Form.Group>
                  <Form.Label> {lang.text_city} <span className='required-feild'>*</span></Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-city"
                    name="person-city"
                    isInvalid={this.state.cityErr}
                    type="text"
                    value={this.state.city}
                    onChange={(e) => {
                      this.onInputChange('city', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.city && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_city}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group>
                  <Form.Label> {lang.text_zip_code} <span className='required-feild'>*</span></Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-zip"
                    name="person-zip"
                    isInvalid={this.state.zipErr}
                    type="number"
                    value={this.state.zip}
                    onChange={(e) => {
                      this.onInputChange('zip', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.zip && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_zip_code}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label> {lang.text_company_email} <span className='required-feild'>*</span></Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-email"
                    name="person-email"
                    isInvalid={this.state.companyErr}
                    type="text"
                    value={this.state.companyEmail}
                    onChange={(e) => {
                      this.onInputChange('companyEmail', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.companyEmail && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_company}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Form.Group>
                  <Form.Label> {lang.text_company_phone} (optional)</Form.Label>
                  <Skeleton visible={skeletonLoading}>
                  <Form.Control
                    id="person-phone"
                    name="person-phone"
                    isInvalid={this.state.companyErr}
                    type="text"
                    value={this.state.companyPhoneNumber}
                    onChange={(e) => {
                      this.onInputChange('companyPhoneNumber', e.target.value);
                    }}
                    onBlur={(e)=> {
                      e.preventDefault();
                      e.target.value !== this.state.prevState.companyPhoneNumber && this._put_userAccountInfo();
                    }}
                  />
                  </Skeleton>
                  <Form.Control.Feedback className="err" type="invalid">
                    {' '}
                    {lang.text_invalid_company}{' '}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            
            {!propertyOwnerInfoEnabled && 
            <Row>
              <Col xs={12}>
                <span onClick={()=> this.props.history.push('/property/propertyOwnerInformation')} style={{fontSize: '12px', color: '#5555FF', cursor: 'pointer', fontWeight: 400, width: 'fit-content'}}>Bitte klicken Sie hier um für diese Immobilie spezifische Eigentümerinformationen zu erfassen. <img src={RightArrowPartner} style={{marginTop: '0px', width: '12px'}}/></span>
              </Col>
            </Row>}
            
            <Row>
              <Col xs={12}>
                <label className='tooltips company-logo-upload-label' style={{marginTop: '18px', marginBottom: '20px'}}> {'Eigenes Logo'}</label>
                {(currentSubscription === null || currentSubscription === undefined || isStarterTier(currentSubscription)) ?
                  <div style={{background: 'white', padding: '16px', height: '280px', borderRadius: '4px'}}>
                    <Stack align={'center'} style={{height: '100%', justifyContent: 'center'}}>
                      <Stack gap={0} style={{}}>
                        <span style={{color: '#0E0E1D', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Ihr eigenes Logo verwenden.</span>
                        <span style={{color: '#5555FF', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Mit hellohousing Premium.</span>
                      </Stack>
                      <Group>
                        <div>
                          <ColorButton
                          text={hasTested ? 'Jetzt freischalten' : 'Kostenlos testen'}
                          className='purple-btn'
                          onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})}
                          />
                        </div>
                      </Group>
                      <Group>
                        <span style={{color: '#0E0E1D', fontSize: '12px', textAlign: 'center'}}>Verwenden Sie ein eigenes Logo auf allen Mieter-Dokumenten wie Betriebskostenabrechnungen und Ableseprotokollen.</span>
                      </Group>
                    </Stack>
                  </div>
                  :
                  <div className="profile-image-container" style={{margin: '0 0 18px 0', flexDirection: 'column'}}>
                    <Stack style={{marginBottom: '20px'}}>
                      {logoPreference !== 'None' &&
                      (logoPreference === 'SystemDefault' ? 
                        this.renderLogo()
                        :
                        (logoPreference === 'UserDefined' && this.state.file) ?
                          this.renderLogo()
                          :
                          <EmptyStateContainer
                          heading={"Kein Logo verfügbar"}
                          subheading={"Laden Sie ein eigenes Logo hoch."}
                          icon={Avatar}
                          showBtn={false}
                          styleMainContainer={{marginTop: 10, maxWidth: '200px'}}
                          />
                      )}
                      <Skeleton visible={skeletonLoading} width={300}>
                        <SwitchContainer
                        className={'tooltips logo-prefernce-none'}
                        textClassName={'is-account-logo-hidden-text'}
                        onChange={() => {
                          this.setState({logoPreference: logoPreference === 'None' ? 'SystemDefault' : 'None'}, ()=> {
                            this.props.setIsLogoHidden(logoPreference === 'None');
                            this._put_userAccountInfo();
                          });
                        }}
                        checked={logoPreference === 'None'}
                        switchText={`${getBrandingPartner(accountData, currentSubscription)?.name || 'hellohousing'} Logo ausblenden`}
                        disabled={false}
                        />
                      </Skeleton>
                      <Skeleton visible={skeletonLoading} width={300}>
                        <SwitchContainer
                        className={'tooltips logo-prefernce-user-defined'}
                        onChange={() => {
                          this.setState({logoPreference: logoPreference === 'UserDefined' ? 'SystemDefault' : 'UserDefined'}, ()=> {
                            this.props.setCompanyLogo(logoPreference);
                            this._put_userAccountInfo();
                          });
                        }}
                        checked={logoPreference === 'UserDefined'}
                        switchText={'Eigenes Logo verwenden'}
                        disabled={false}
                        />
                      </Skeleton>
                    </Stack>
                    {enableCompanyLogoUse === 'UserDefined' && skeletonLoading &&
                    <Skeleton visible={skeletonLoading} mb={'xl'} height={72} width={142} style={{marginRight: '24px', marginBottom: '16px'}}/>}
                    {enableCompanyLogoUse === 'UserDefined' &&
                    <>
                      <div className="upload-container" style={{marginTop: 0, opacity: isLogoHiddenState && 0.6}}>
                        <div className="property-input-box">
                          <div id="save_userProfile_picture">
                          {skeletonLoading?
                            <Skeleton visible={skeletonLoading} width={125} height={36} style={{marginBottom: '13px'}}/>
                            :  
                            <label className="upload-btn gray-btn"
                            onClick={()=> this.setState({buyPremiumModalOpen: isStarterTier(currentSubscription) ? true : false})}
                            style={{
                              fontWeight: '500',
                              fontSize: '14px',
                              fontFamily: 'sans-serif',
                              padding: '7px 11px'
                            }} htmlFor="uploadProfileImage_general">
                              {'Logo hochladen'}
                            </label>}
                            {!isStarterTier(currentSubscription) && 
                            <input
                              id="uploadProfileImage_general"
                              name="uploadProfileImage_general"
                              style={{ display: 'none' }}
                              type="file"
                              accept="image/*"
                              disabled={isLogoHiddenState}
                              onChange={this.handlePictureUpload_general}
                            />}
                          </div>
                          <div id="delete-user-profile-button_id">
                            <button
                              className="delete-propertypicture-button"
                              disabled={isLogoHiddenState}
                              onClick={(e) => {
                                e.preventDefault();
                                !isStarterTier(currentSubscription) && this.setState({ file: '', fileToUpload: '', fileUploadErr: { state: false, msg: '' } },()=> this.deleteCompanyPicture(this.props.profile.accountId, null));
                              }}
                            >
                              <Skeleton visible={skeletonLoading}>
                                {lang.text_delete}
                              </Skeleton>
                            </button>
                          </div>
                        </div>
                        <span className="file-desc" style={{whiteSpace: 'nowrap'}}>{lang.text_upload_photo_ins_svg}</span>
                        <span className="file-err">{this.state.fileUploadErr.state && this.state.fileUploadErr.msg}</span>
                      </div>
                    </>}
                  </div>}
              </Col>
            </Row>
          </div>
          

          <div className="danger-zone">
            <label className='tooltips delete-account mb-3' style={{marginTop: '18px'}}> {lang.text_danger_zone}</label>
            <div id="delete-user-profile">
            <Skeleton visible={skeletonLoading} style={{width: 'fit-content'}}>
              <TransparentButton
                className="danger-btn"
                onClick={() => {
                  this.toggleDeleteAccountModal();
                  window.Intercom('trackEvent', 'account-deletion-started');
                }}
                text={<span style={{whiteSpace: isMobile && 'normal'}}>{lang.text_delete_your_account}</span>}
                textStyle={{textAlign: 'left'}}
              />
            </Skeleton>
            </div>
          </div>
        </div>
        <DeleteModal
          open={this.state.deleteAccountModal}
          className="delete-rent-modal"
          toggle={this.toggleDeleteAccountModal}
          record={this.state.accountID}
          handleDelete={() => this.cancelSubscriptionAPi()}
          type={'Nutzerprofil'}
          showtext={false}
          typeText={
            <div>
              <p>
                Sind Sie sicher, dass Sie Ihr hellohousing Konto löschen wollen? Sie können die hellohousing App dann nicht mehr nutzen und auch nicht mehr auf Ihre Daten zugreifen.
              </p>
              <p>
                <span style={{fontStyle: 'italic', fontWeight: 'bold'}}>Hinweis:</span> hellohousing speichert Ihre Daten für weitere 90 Tage. Danach werden die Daten <span style={{fontWeight: 'bold'}}>automatisch und unwiderruflich</span> gelöscht. Sie können sich an den hellohousing Service (<a href='mailto:service@hellohousing.de'>service@hellohousing.de</a>) wenden, um Ihre Daten sofort löschen zu lassen oder eine Wiederherstellung des Nutzerkontos zu beantragen.
              </p>
              <p>
                Sind Sie sicher, dass Sie mit der Löschung des Nutzerkontos fortfahren wollen?
              </p>
            </div>
          }
          modalId="delete-data-property"
          showDeleteText={false}
          textShowModal='Nutzerkonto löschen'
        />
        <BuyPremiumModal
        heading={'Premium'}
        open={buyPremiumModalOpen}
        text={<span style={{fontSize: '15px', color: '#727293', fontWeight: '400'}}>Schalte weitere Mieteinheiten und vieles mehr mit dem <span onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})} style={{color: '#13135C', textDecoration: 'underline', cursor: 'pointer'}}>{isStarterTier(currentSubscription) ? 'Premium-Paket' : 'Professional-Paket'}</span> frei.</span>}
        onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})}
        onCancel={()=> this.setState({buyPremiumModalOpen: false})}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.generalReducer.profile,
    AccountApi: state.generalReducer.account_api_id,
    currentSubscription: state.generalReducer.currentSubscription,
    companyLogoEnable: state.generalReducer.companyLogoEnable,
    accountData: state.generalReducer.accountData,
    hasTested: state.generalReducer.hasTested,
    isLogoHidden: state.generalReducer.isLogoHidden,
    propertySelected: state.generalReducer.property
  };
};

const actions = {
  updateUserProfile,
  Account_info,
  updateProfilePicture,
  setProfileData,
  setCompanyLogo,
  updateCompanyLogo,
  setAccountData,
  setIsLogoHidden
};

export default connect(mapStateToProps, actions)(CompanyDetails);
